<template>
  <router-link :to="{ name: toNamedRoute }">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="c_card pa-3">
          <div class="c_icon">
            <div class="circle">
              <slot></slot>
            </div>
          </div>
          <div class="content">
            <div class="font-weight-bold subheading content_title">
              {{ title }}
            </div>
            <div class="font-weight-bold title content_count">
              <span class="content_today-color">{{ today }}</span>
              <span v-show="!isAforo" class="content_today-color">
                {{ nanHandle(roundAbsNumber(percentage)) }}%
              </span>
            </div>
            <div v-show="!isAforo" class="content_percent">
              <span :class="colors[colorIndicator]">
                <!-- {{ total }} ---{{ today }}----{{ yesterday }} -->
                <!-- <br>
            {{ typeof today }}
            <br>
            {{ typeof yesterday }} -->
                <v-icon
                  v-if="colorIndicator === 'more'"
                  class="subheading"
                  color="green"
                >
                  arrow_upward
                </v-icon>
                <v-icon
                  v-if="colorIndicator === 'less'"
                  class="subheading"
                  color="primary"
                >
                  arrow_downward
                </v-icon>
                <span v-if="colorIndicator === 'same'">~</span>
                {{ nanHandle(roundAbsNumber(percentageComparison)) }}%
              </span>
            </div>
          </div>
        </div>
      </template>
      Ver más
    </v-tooltip>
  </router-link>
</template>

<script>
export default {
  props: {
    isAforo: {
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    toNamedRoute: {
      type: String,
      default: '',
      required: true,
    },
    total: {
      type: Number,
      default: 0,
      required: true,
    },
    today: {
      type: Number,
      default: 0,
      required: true,
    },
    yesterday: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data: () => ({
    colors: {
      more: 'green--text',
      less: 'primary--text',
      same: 'gray--text',
    },
  }),
  methods: {
    roundAbsNumber(num) {
      return isNaN(num) ? undefined : Math.abs(Math.round(num))
    },
    nanHandle(num) {
      return num === undefined ? '~' : num
    },
  },
  computed: {
    colorIndicator() {
      if (Math.sign(this.percentageComparison) === 1) return 'more'
      if (Math.sign(this.percentageComparison) === -1) return 'less'
      return 'same'
    },
    percentage() {
      if (typeof this.today !== 'number' || typeof this.total !== 'number') {
        return undefined
      }

      if (this.total === 0 || this.today === 0) {
        return 0
      }

      return (this.today * 100) / this.total
    },
    percentageComparison() {
      if (this.total === 0) {
        const a =
          (this.today * 100) / this.today - (this.yesterday * 100) / this.today
        return isNaN(a) ? undefined : a
      }

      if (
        typeof this.today !== 'number' ||
        typeof this.yesterday !== 'number' ||
        this.yesterday === 0
      ) {
        return undefined
      }

      if (this.percentage === undefined) {
        return 0 - (this.yesterday * 100) / this.total
      }

      return this.percentage - (this.yesterday * 100) / this.total
    },
  },
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.c_card {
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
  min-height: 130px;
  transition: transform 0.5s ease-out;
}
.c_card:hover {
  transform: translateY(-10px);
  box-shadow: #ef565c 0px 2px 8px 0px;
}
.c_icon {
  width: 30%;
}
.circle {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  background-color: #f4f7fe;
  padding: 10px;
  width: 50px;
  height: 50px;
}
.content {
  width: 70%;
}
.content_title {
  color: #a3aed0;
  text-align: left;
}
.content_count {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.content_percent {
  text-align: right;
}
.content_today-color {
  color: #2b3674;
}
</style>
